import classnames from 'classnames'

import styles from './skeleton.module.scss'

const RADIUS_BY_VARIANT = {
  RECTANGULAR: '5px',
  CIRCLE: '50%',
  NONE: undefined,
} as const

interface SkeletonProps {
  height?: number
  width?: number
  variant?: 'RECTANGULAR' | 'CIRCLE' | 'NONE'
  className?: string
  fullWidth?: boolean
  fullHeight?: boolean
  productCardSkeletonWrapper?: boolean
}

function Skeleton({
  height = 15,
  width = 100,
  variant = 'RECTANGULAR',
  className,
  fullWidth,
  fullHeight,
  productCardSkeletonWrapper,
}: SkeletonProps) {
  return (
    <div
      style={{
        height: fullHeight ? `100%` : `${height}px`,
        width: fullWidth ? '100%' : `${width}px`,
        borderRadius: RADIUS_BY_VARIANT[variant],
      }}
      className={classnames(styles.skeletonWrapper, className, {
        [styles.productCardSkeletonWrapper]: productCardSkeletonWrapper,
      })}
    />
  )
}

export default Skeleton
